// BG
export const locale = {
  GENERAL: {
    APP_TITLE: "Люник ЕООД"
  },
  TRANSLATOR: {
    SELECT: "Избери своя език"
  },
  DRIVER_ACCESS: {
    LOGIN_TITLE: "Вход за шофьори",
    LOGIN_HELP: "Въведете регистрационния номер на машината и шофьорската парола.",
    REGISTRATION_PLATE: "Регистрационен номер",
    PASSWORD: "Парола",
    LOGIN_BUTTON: "Вход",
    REQUIRED_LOGIN_FIELDS: "Моля, попълнете регистрационен номер и парола.",
    LOGIN_ERROR: "Възникна грешка при вход.",
    INVALID_LOGIN: "Невалиден регистрационен номер или парола.",
    LOGIN_SUCCESS: "Входът е успешен.",
    MACHINE_TITLE: "Машина",
    LOADING: "Зареждане...",
    MACHINE_TYPE: "Тип",
    SERVICE_TYPE: "Дейност",
    SIGNAL: "Сигнал",
    LOGOUT: "Изход",
    SIGNAL_SUCCESS: "Сигналът е изпратен успешно.",
    DATE_TIME: "Дата и час",
    DESCRIPTION: "Описание на проблема",
    DESCRIPTION_PLACEHOLDER: "Опишете проблема с машината",
    SEND_SIGNAL: "Изпрати сигнал",
    DESCRIPTION_REQUIRED: "Моля, опишете проблема с поне 3 символа.",
    DATE_TIME_REQUIRED: "Моля, изберете дата и час.",
    SIGNAL_ERROR: "Възникна грешка при изпращане.",
    CURRENT_WORK: "Текуща работа",
    DETAILS: "Детайли",
    SERVICE_HISTORY: "История на обслужванията",
    SIGNALS_AND_TASKS: "Сигнали и задачи",
    REPORT_SIGNAL: "Подай сигнал",
    SERVICE_VISIT: "Сервизно посещение",
    ON_ROAD: "На път",
    NO_TASKS: "Няма задачи към това сервизно посещение.",
    NO_CURRENT_WORK: "Няма текуща сервизна работа.",
    AWAITING_ASSIGNMENT: "Подадени сигнали, чакащи разпределение",
    SERVICE_RECORD: "Сервизен запис",
    KILOMETERS: "км",
    MOTO_HOURS: "моточаса",
    NO_SERVICE_HISTORY: "Няма история на обслужванията.",
    NO_WORK_HISTORY: "Няма история на сигнали или задачи.",
    PREVIOUS: "Назад",
    NEXT: "Напред",
    PAGE: "Страница {page}",
    DASHBOARD_ERROR: "Сервизната информация не може да бъде заредена. Опитайте отново."
  },
  MECHANIC_HOURS: {
    SAVED_SUCCESS: "Часовете на механиците са записани успешно.",
    DELETED_SUCCESS: "Часовете на механиците са изтрити успешно."
  },
  SERVICE_INVOICES: {
    MILEAGE: "Километри/моточасове"
  },
  MACHINE_SERVICE_SIGNALS: {
    TITLE: "Сигнали за сервиз на машини",
    LIST: "Списък",
    SHOW: "Преглед",
    DATE_TIME: "Дата и час",
    MACHINE: "Машина",
    STAFF: "Служители",
    DESCRIPTION: "Описание",
    LOADING: "Зареждане... Моля изчакайте",
    NOT_FOUND: "Записът не е намерен."
  },
  SERVICE_VISITS: {
    BOARD: "Табло",
    CALENDAR: "Календар",
    ITEMS: "Елементи",
    CUSTOM_TASK: "Допълнителна задача",
    CUSTOM_TASKS: "Допълнителни задачи",
    TASKS: "Задачи",
    HOURS_SHORT: "ч.",
    NO_VISITS_IN_STATUS: "Няма сервизни посещения",
    NO_VISITS_IN_MONTH: "Няма сервизни посещения за избрания месец",
    LIST_LOAD_ERROR: "Сервизните посещения не могат да бъдат заредени. Опитайте отново.",
    NO_CUSTOM_TASKS: "Няма добавени допълнителни задачи",
    SELECT_MACHINE_FIRST: "Първо изберете машина.",
    NO_SIGNALS: "Няма текущи сигнали за тази машина.",
    NO_SERVICE_TYPES: "Няма дейности, свързани с тази машина.",
    LAST_SERVICE: "Последно обслужване",
    NO_LAST_SERVICE: "Няма предишно обслужване",
    COMPLETION_MILEAGE_TITLE: "Приключване на сервизно посещение",
    COMPLETION_DETAILS_TITLE: "Приключване на сервизно посещение",
    COMPLETION_KILOMETERS: "Километри",
    COMPLETION_MOTO_HOURS: "Моточасове",
    MOTO_HOURS_SHORT: "ч.",
    COMPLETION_MILEAGE_REQUIRED: "Въведете текущите километри или моточасове, за да приключите посещението.",
    TASKS_MUST_BE_TERMINAL: "Всички задачи трябва да са приключени или отказани, преди посещението да бъде приключено.",
    HOURS_WORKED: "Отработени часове",
    WORK_DONE: "Извършена работа",
    TASK_STATUS_UPDATED: "Статусът на задачата е обновен.",
    TASK_UPDATED: "Задачата е обновена.",
    TASK_CREATED: "Задачата е създадена.",
    TASKS_REORDERED: "Редът на задачите е обновен.",
    START_WORK: "Започни работа",
    FINISH_VISIT: "Приключи посещението",
    STATUS_UPDATED: "Статусът на посещението е обновен.",
    STATUS_UPDATE_FAILED: "Статусът на посещението не може да бъде обновен.",
    VISIT_REORDERED: "Редът на посещенията е обновен.",
    VISIT_REORDER_FAILED: "Редът на посещенията не може да бъде обновен.",
    TASK_DETAILS: "Детайли за задача",
    ADD_TASK: "Добави задача",
    TASK_NAME: "Име на задача",
    TASK_UPDATE_FAILED: "Моля, попълнете всички задължителни полета правилно.",
    HISTORY: {
      TITLE: "История",
      ADD_COMMENT: "Добави коментар",
      EDIT_COMMENT: "Редактирай коментар",
      COMMENT: "Коментар",
      COMMENT_REMOVED: "Коментарът е изтрит",
      COMMENT_SAVE_FAILED: "Коментарът не може да бъде запазен.",
      COMMENT_DELETE_FAILED: "Коментарът не може да бъде изтрит.",
      EDITED: "редактиран",
      CREATED: "Създадено е сервизно посещение",
      UPDATED: "Обновено е сервизно посещение",
      DELETED: "Изтрито е сервизно посещение",
      SYSTEM: "Система",
      MECHANIC_ADDED: "Добавен механик: {name}",
      MECHANIC_REMOVED: "Премахнат механик: {name}",
      TASK_ADDED: "Добавена задача: {name}",
      TASK_REMOVED: "Премахната задача: {name}",
      TASK_UPDATED: "Обновена задача: {name} — {changes}",
      FIELD_CHANGED: "{field}: {before} → {after}",
      SNAPSHOT_MACHINE: "Машина: {name}",
      SNAPSHOT_STATUS: "Статус: {name}",
      SNAPSHOT_PRIORITY: "Приоритет: {name}",
      SNAPSHOT_PERIOD: "Период: {from} – {to}",
      SNAPSHOT_MECHANICS: "Механици: {names}",
      FIELDS: {
        MACHINE: "Машина",
        STATUS: "Статус",
        PRIORITY: "Приоритет",
        IS_ON_ROAD: "На път",
        ON_ROAD_NOTE: "Бележка за пътя",
        SERVICE_LOCATION: "Местоположение",
        DATE_FROM: "Начална дата",
        DATE_TO: "Крайна дата",
        DURATION: "Продължителност",
        SERVICE_MILEAGE: "Километри/моточасове",
        HOURS_WORKED: "Отработени часове",
        WORK_DONE: "Извършена работа",
        NAME: "Описание",
        NOTE: "Бележка"
      }
    }
  },
  SERVICE_MACHINE_ROWS: {
    PAST_ROWS: "Предишни сервизни записи",
    LOCKED_BY_SERVICE_VISIT:
      "Този запис е създаден от сервизно посещение и не може да бъде редактиран или изтрит.",
    VIEW_SERVICE_VISIT: "Преглед на сервизното посещение"
  },
  MENU: {
    SECTION: {
      SETTINGS: "Настройки",
      PRODUCTS: "Продукти",
      WAREHOUSE: "Склад",
      WAREHOUSE_ITEM: "Артикул на склад"
    },
    ITEM: {
      DASHBOARD: "Начало",
      LIST: "Списък",
      ADD: "Добавяне",
      EDIT: "Редактиране",
      ACTIVE: "Активен",
      STATUS: "Статус",
      ACTIONS: "Опции",
      STATISTICS: {
        STATISTICS: "Статистики",
        SALES_BY_GROUPS: "Продажби по групи",
        SALES_BY_DAYS: "Продажби по дни",
        DELAYED_ORDERS: "Закъснели поръчки"
      },
      ASL: {
        BULSTAT: "Булстат",
        ASL: "Възложители и обекти",
        ASSIGNORS_GROUPS: "Групи възложители",
        GROUP: "Група",
        ASSIGNORS_GROUPS_LIST: "Списък Групи възложители",
        ASSIGNORS: "Възложители",
        ASSIGNOR: "Възложител",
        ASSIGNORS_LIST: "Списък възложители",
        COMPANY: "Фирма",
        LOCATION_NAME: "Име на локацията",
        LOCATION_PLACEHOLDER_NAME: "Мусачево",
        LOCATIONS: "Обекти",
        LOCATION: "Обект",
        NUMBER: "Номер",
        ASSIGNORS_LOCATIONS: "Обекти възложители",
        COMPANY_NAME: "Фирма",
        GAS_STATION_NAME: "Име/бранд на бензиностанцията",
        GAS_STATION_NAME_PLACEHOLDER: "АИМ",
        LOCATION_PLACE_NAME: "Местонахождение",
        LOCATION_PLACE_NAME_PLACEHOLDER: "Драгоман",
        LOCATION_KARIERA: "Кариера/Разтоварище",
        CODE: "Код"
      },
      EXECUTORS: {
        EXECUTORS: "Изпълнители",
        EXECUTOR: "Изпълнител",
        EXECUTORS_LIST: "Списък изпълнители",
        EXECUTORS_ADD: "Добавяне изпълнител",
        EXECUTORS_EDIT: "Редактиране изпълнител"
      },
      ASSETS: {
        ASSETS: "Активи",
        STAFF: "Служители",
        MACHINES: "Машини",
        MACHINE: "Машина",
        LIST: "Списък",
        MACHINES_TYPES: "Типове машини",
        MACHINE_TYPE: "Тип машина",
        OWNED_MACHINES: "Собствени машини",
        OWN_MACHINE: "Лична машина",
        RENTED_MACHINES: "Наети машини",
        RENTED_MACHINE: "Наета машина"
      },
      ACTIVITIES: {
        ASSIGNMENTS: "Ангажименти",
        ACTIVITIES: "Дейности",
        BILL_OF_LADING: "Товарителници",
        EXTERNAL_BILL_OF_LADING: "Люник Строй товарителници",
        BILL_OF_LADING_SINGLE: "Товарителница",
        BILL_OF_LADING_NUMBER: "Номер",
        BILL_OF_LADING_DATE: "Дата",
        PROTOCOLS: "Протоколи",
        PROTOCOL: "Протокол",
        BILL_OF_LADING_NOTE: "Забележка",
        BILL_OF_LADING_WORKING_DATE: "За дата"
      },
      PROTOCOLS: {
        PROTOCOLS: "Протоколи",
        PROTOCOL: "Протокол"
      },
      ROLES: {
        ROLES: "Роли"
      },
      USERS: {
        USERS: "Потребители"
      },
      SUBC: {
        SUBCONTRACTORS: "Подизпълнители",
        SUBCONTRACTOR: "Подизпълнител",
        SUBCONTRACTORS_LIST: "Списък подизпълнители",
        SUBCONTRACTORS_TYPES: "Типове подизпълнители",
        NAME: "Име",
        COMPANY_NAME: "Име на фирмата",
        ADDRESS: "Адрес",
        MOL: "МОЛ",
        VAT: "ДДС",
        EIK: "ЕИК",
        EMAIL: "Мейл",
        PHONE: "Телефон",
        SUBCONTRACTOR_TYPE: "Тип",
        SUBCONTRACTORS_LOCATIONS: "Обекти подизпълнители",
        COMPANY: "Фирма",
        LOCATION: "Обект"
      },
      EXP: {
        EXPENSES: "Разходи",
        FUELS: "Горива",
        SUBCONTRACTORS: "Подизпълнители",
        FUELS_EXPENSES: "Разходи горива",
        FUEL_EXPENSE_ROWS: "Разходи горива - редове",
        FUELABLE_TYPE: "Заредил",
        SUB_EXPENSES: "Разходи подизпълнители",
        SUB_EXPENSES_MATERIALS: "Разходи материали",
        INVOICES: "Фактури",
        INCOME_INVOICES: "Приходни фактури",
        SERVICE: "Сервиз",
        AI_INVOICES: "AI Фактури",
        AI_COMPANIES: "AI Фирми",
        AI_INVOICE_ACCOUNTING_VALUE_TYPES: "AI Счетоводни сметки",
        AI_INVOICE_ACCOUNTING_VALUES: "AI Счетоводни сметки кодове",
        AI_INVOICE_TYPE: "AI Вид фактура"
      },
      AI_INVOICES: {
        LIST: "Списък AI фактури",
        TYPE_ADMINISTRATIVE_EXPENSES: "Административни разходи (Администрация)",
        TYPE_FUELS: "Горива",
        TYPE_MATERIALS_EXPENSES_LYUNIK:
          "Разходи за материали (Кариери/Разтоварища – Люник)",
        TYPE_MATERIALS_SERVICES_LYUNIK_STROI:
          "Разходи за материали и услуги за обекти (Люник строй)",
        TYPE_MECHANIZATION_SERVICE: "Механизация - сервиз",
        TYPE_MECHANIZATION_SUBCONTRACTORS: "Механизация - подизпълнители",
        TYPE_OTHER_INVOICES: "Други фактури"
      },
      AI_INVOICE_ACCOUNTING_VALUE_TYPES: {
        LIST: "Списък AI счетоводни сметки",
        ADD: "Добави AI счетоводен сметки",
        EDIT: "Редактирай AI счетоводен сметки"
      },
      AI_COMPANIES: {
        LIST: "Списък AI фирми",
        ADD: "Добави AI фирма",
        EDIT: "Редактирай AI фирма"
      },
      INC: {
        INCOME: "Приходи",
        ASSIGNORS: "Възложители"
      },
      REF: {
        REFERENCES: "Справки"
      },
      FUELS: {
        FUELS: "Горива",
        FUELS_TYPES: "Видове горива",
        FUEL_TYPE: "Вид гориво",
        NAME: "Име",
        FUEL_PRICE: "Цена на литър",
        LITERS: "Литри",
        CHARGED_FROM: "Зареждане oт",
        CHARGED_FROM_PLACE: "Място",
        INVOICE_NUMBER: "Фактура",
        DATE_CHARGED: "Дата на зареждане",
        MSM: "Машиносмени",
        MILEAGES: "Километри/моточасове",
        AVG_PRICE: "Средна цена",
        AVAILABLE_LITERS: "Налични литри",
        TITLE: "Зареждане от бидони",
        GPS_TITLE: "GPS - зареждане от бидони",
        EXPENSE: "Разход"
      },
      TANKS: {
        NAME: "Име",
        TANK: "Бидон",
        TANKS: "Бидони",
        GPS_TANKS: "GPS - бидони",
        FORM_LABELS: "Зареждане бидони",
        TANK_CHARGES: "Зареждане бидони",
        CHARGES: "Зареждания",
        CHARGED_FROM: "Зареждане oт",
        VEHICLE_GAS_STATION: "Автомобил/бидон",
        FROM: "От",
        VEHICLE: "Автомобил",
        TANK_CAPACITY: "Вместимост/обем литри",
        CAPACITY: "Вместимост",
        TANK_CAPACITY_PLACEHOLDER: "1150",
        GAS_STATION: "Бензиностанция",
        CONFIRM_CHARGES: "Потвърди зареждания",
        SYNC: "Синхронизиране",
        MARK_AT_LEAST_ONE_CHARGE:
          "Моля маркираите поне едно зареждане от списъка",
        CONFIRM_TRANSFER: "Желаете ли да прехвърлите {value} зарежданe/ия"
      },
      SRV: {
        SERVICES: "Услуги",
        SERVICE: "Услуга",
        SERVICE_NAME: "Име на услугата",
        QTY: "Брой"
      },
      MEASURES: {
        MEASURES: "Мерки",
        MEASURE: "Мярка"
      },
      SETTINGS: {
        SETTINGS: "Настройки",
        USERS: "Потребители",
        STAFF: "Служители",
        LOCATIONS: "Локации",
        GENERAL: "Други настройки",
        ROLES: "Роли",
        STAFF_VEHICLE: "Лични автомобили",
        GAS_STATIONS: "Бензиностанции",
        GAS_STATION_NAME: "Име на бензиностанция",
      },
      STAFF: {
        PLACEHOLDER_HOURLY_RATE: "10.90",
        FIRST_NAME: "Име",
        LAST_NAME: "Фамилия",
        HOURLY_RATE: "Часова ставка",
        STAFF_VEHICLE: "Лични автомобили",
        REGISTRATION_PLATE: "Регистрационнен номер",
        STAFF: "Служител",
        STAFF_NAMES: "Служител име фамилия",
        STAFF_TYPE: "Тип служител"
      },
      ITEMS: {
        ALL: "Продукти/Съставки",
        PRODUCTS: "Продукти",
        INGREDIENTS: "Съставки",
        ITEM_CATEGORIES: "Категории",
        RECIPES: "Рецепти",
        PRICES: "Цени",
        PROMOTIONS: "Промоции"
      },
      SERVICE: {
        TYPES: "Дейности и такси",
        WAREHOUSES: "Складове",
        WAREHOUSE_ITEMS: "Артикули на склад",
        VENDORS: "Доставчици",
        LOCATIONS: "Сервизни локации",
        MECHANICS: "Механици",
        MECHANIC_HOURS: "Часове механици",
        MACHINES: "Обслужване и разходи",
        MACHINE_SERVICE: "Обслужване",
        MACHINE_EXPENCE: "Планови разходи",
        MACHINE_SERVICE_SIGNALS: "Сигнали за сервиз на машини",
        VISITS: "Сервизни посещения",
        VISITS_BOARD: "Табло сервизни посещения",
        VISITS_CALENDAR: "Календар сервизни посещения",
        VISIT_COMMENTS: "Коментари към сервизни посещения",
        INVOICES: "Фактури",
        MACHINE_SERVICES: "Обслужвание и разходи за {machine}"
      }
    }
  },
  BUTTON: {
    CHECKBOXES: "Отметки",
    CANCEL: "Отказ",
    NEW: "Нов",
    SEND: "Изпрати",
    READY: "Готово",
    FULLSCREEN: "Цял екран",
    BACK: "Назад",
    ADD: "Добави",
    ADD_NEW: "Добави нов",
    DELETE: "Изтрий",
    SAVE: "Запази",
    COPY: "Копирай",
    DUPLICATE: "Дублирай",
    SAVE_AND_CONTINUE: "Запази и продължи",
    SAVE_AND_COPY: "Запази и копирай",
    SAVE_AND_ADD_NEW: "Запази и добави нов",
    SAVE_AND_EXIT: "Запази и излез",
    SET_NEW_PASSWORD: "Промени Паролата",
    NO_NEW_PASSWORD: "Не Променяй Паролата",
    GENERATE_PASSWORD: "Генерирай Парола",
    GENERATE: "Генерирай",
    CONTINUE: "Продължи",
    UPLOAD: "Качи",
    REFRESH: "Презареди",
    FILES: "Файлове",
    DOWNLOAD: "Свали",
    CLOSE: "Затвори",
    CONFIRM: "Потвърди",
    ALL: "Всички",
    APPLY: "Приложи",
    APPLY_FOR_ALL_STORES: "Приложи за всички магазини",
    CREATE: "Създай",
    PLEASE_CONFIRM: "Моля потвърдете",
    ACTIONS: "Действия",
    FINALIZE: "Финализирай",
    PREVIEW: "Преглед",
    PRINT: "Разпечатай",
    EXCEL: "Ексел",
    ADD_INVOICE: "Фактурирай",
    PDF: "PDF",
    PDFPRINT: "PDF/PRINT",
    SEND_ASSIGNMENT_NOTIFICATIONS: "Изпрати график по Viber",
    TEST_ERRORS: "Тест грешки",
    TRANSFER: "Прехвърли"
  },
  TABLE: {
    ITEMS_PER_PAGE_TEXT: "Резултати на страница"
  },
  AUTH: {
    GENERAL: {
      FOOTER_LEFT: "Люник ЕООД",
      WELCOME: "Люник ЕООД",
      WELCOME_DESCRIPTION: "Платформа за управление",
      SIGNUP_BUTTON: "Вход",
      BACK_BUTTON: "Назад",
      PRIVACY: "Политика за поверителност"
    },
    LOGIN: {
      TITLE: "Вход",
      DESCRIPTION:
        "Моля свържете се с администратор за да получите потребителско име и парола",
      VALID_EMAIL: "Въведете валиден имейл.",
      VALID_PASSWORD: "Паролата е задължителна.",
      VALID_PASSWORD_CONFIRM: "Паролите не съвпадат.",
      BUTTON: "Вход",
      PRIVACY: "",
      LEGAL: "",
      CONTACT: ""
    },
    TWO_FACTOR: {
      TITLE: "2FA",
      DESCRIPTION:
        "За да продължите, въведете 6 цифрения код изпратен на вашия имейл!",
      CODE: "Код",
      VALID_CODE: "Въведете валиден код."
    },
    FORGOT: {
      TITLE: "Забравена парола?",
      SUCCESS: "Ще получите имейл с линк за рестартиране на паролата си.",
      DESC: "Въведете вашия имейл, за да рестартирате паролата си!"
    },
    RESET: {
      TITLE: "Въведете вашата нова парола",
      DESC: "Въведете вашия имейл, за да рестартирате паролата си!",
      SUCCESS: "Вашата парола беше успешно рестартирана."
    },
    REGISTER: {
      TITLE: "Регистрация",
      DESC: "Въведете вашите данни, за да създадете акаунт",
      SUCCESS: "Вашият акаунт е създаден успешно."
    },
    INPUT: {
      EMAIL: "Имейл",
      FULLNAME: "Имена",
      PASSWORD: "Парола",
      CONFIRM_PASSWORD: "Потвърдете парола",
      USERNAME: "Потребителско име"
    }
  },
  VALIDATION: {
    VALID: "",
    INVALID: "Полето {name} е невалидно",
    REQUIRED: "Полето {name} е задължително",
    LENGTH: "Полето {name} трябва да е {length} символа",
    MIN_LENGTH: "Полето {name} трябва да е минимум {min} символа",
    AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
    NOT_FOUND: "The requested {name} is not found",
    INVALID_LOGIN: "The login detail is incorrect",
    REQUIRED_FIELD: "Required field",
    MIN_LENGTH_FIELD: "Minimum field length:",
    MAX_LENGTH_FIELD: "Maximum field length:",
    INVALID_FIELD: "Field is not valid",
    INVALID_FILE: "Файла не е валиден",
    NO_RESULTS: "Няма намерени резултати.",
    FILE_BIG_SIZE: "Файла е твърде голям. Позволена големина: {value}",
    FILE_TYPE: "Непозволен тип на файл. Позволени типове: {value}"
  },
  PROFILE: {
    TITLE: "Потребителски Профил",
    HI: "Здравей",
    LOGOUT: "Изход",
    MY_PROFILE: "Моя профил",
    PROFILE_SETTINGS: "Настройки на профила"
  },
  FORM: {
    VALID_CODE: "Въведете валиден уникален код.",
    VALID_EMAIL: "Въведете валиден имейл.",
    VALID_NAME: "Полето е невалидно.",
    VALID_TYPE: "Въведете валиден тип.",
    VALID_MACHINE_MODEL: "Въведете валиден модел/марка.",
    VALID_FIRST_NAME: "Въведете валидно име.",
    VALID_LAST_NAME: "Въведете валиднa фамилия.",
    VALID_ACTIVE: "Въведете валиднa стойност за активен:",
    VALID_NO_MILEAGE: "Въведете валиднa стойност за без километраж/моточасове:",
    VALID_ROLE: "Въведете валиднa роля:",
    VALID_IS_ASSIGNABLE: "Да се показва в календар:",
    VALID_PHONE: "Телефоният номер трябва да е точно 10 цифри и да започва с 0"
  },
  SERVICE_VISIT_COMMENTS: {
    TITLE: "Коментари към сервизни посещения",
    ADD: "Добави коментар",
    EDIT: "Редактирай коментар",
    SERVICE_VISIT: "Сервизно посещение",
    AUTHOR: "Автор",
    BODY: "Коментар",
    CREATED_AT: "Създаден на",
    SAVE_FAILED: "Коментарът не може да бъде запазен.",
    DELETE_FAILED: "Коментарът не може да бъде изтрит."
  },
  FORM_LABELS: {
    ACCOUNTING_VALUE_TYPE: "Счетоводна сметка",
    ACCOUNTING_VALUE: "Счетоводен код",
    TO_ACCOUNTING: "За счетоводство",
    HOURS: "Часове",
    CODE: "Код",
    ACTIONS: "Опции",
    IS_SUPPLIER: "Доставчик",
    INVOICE_VALUE: "Стойност на фактурата",
    SUPPLIER: "Доставчик",
    ITEM_NAMES: "Имена на артикули",
    DISCOUNT_PERCENT: "Отстъпка %",
    AMOUNTS: "Суми",
    MOL: "МОЛ",
    AI_COMPANY: "Фирма",
    IS_PROCESSED: "Обработена",
    DISCOUNT: "Отстъпка %",
    TOTAL_WITHOUT_VAT: "Общо без ДДС",
    BULSTAT: "Булстат",
    VAT_NUMBER: "ДДС номер",
    MOL_NUMBER: "МОЛ",
    IS_CONFIRMED: "Потвърдена",
    IS_BUYER: "Купувач",
    VAT_NUMBER: "ДДС номер",
    LINK: "Линк",
    SUPPLIER: "Доставчик",
    BUYER: "Купувач",
    TOTAL_AMOUNT: "Обща сума",
    TAX_AMOUNT: "ДДС сума",
    CURRENCY: "Валута",
    PAYMENT_DEADLINE: "Краен срок за плащане",
    ITEM_NAME: "Артикул",
    QUANTITY: "К-во",
    CODE: "Код:",
    GROUP: "Група",
    EMAIL: "Email адрес:",
    NAME: "Име",
    FIRST_NAME: "Име:",
    LAST_NAME: "Фамилия:",
    ACTIVE: "Активен:",
    NO_MILEAGE: "Без километраж/моточасове:",
    ROLE: "Роля:",
    ROLES: "Роли:",
    PERMISSIONS: "Права:",
    LAT: "Latitude:",
    LNG: "Longitude:",
    LOCATION: "Местоположение",
    IS_ON_ROAD: "На път",
    ON_ROAD_NOTE: "Бележка на път",
    SERVICE_LOCATION: "Локация на сервиза",
    SERVICE_LOCATION_TYPE: "Тип локация на сервиза",
    DATE_TO: "Дата до",
    DURATION: "Продължителност (в часове)",
    PRIORITY: "Приоритет",
    STATUS: "Статус",
    ADDRESS: "Адрес",
    DESCRIPTION: "Описание",
    NOTES: "Бележки:",
    SEARCH_PLACE: "Търси място:",
    CITY: "Град:",
    FROM: "От",
    TO: "До",
    SLUG: "Slug:",
    CLOCK_CODE: "Clock Code:",
    PASS_CODE: "Pass Code:",
    HOURLY_RATE: "Hourly Rate:",
    LANG: "Език:",
    PASSWORD: "Парола:",
    SELECT_ALL: "Избери всички",
    NO_SELECTED: "Няма избрани",
    SELECTED: "Избрани:",
    ALL_SELECTED: "Всички са избрани",
    DEFAULT_COST: "Стойност:",
    PRICE: "Цена",
    DIFFERENT_PRICE: "Различна цена?",
    UNIT_VALUE: "Мерна единица стойност:",
    UNIT: "Мерна единица:",
    SHORTCODE: "Съкращение:",
    SORT: "Подредба:",
    TITLE: "Заглавие:",
    ICON: "Иконка:",
    IMG: "Снимка:",
    VALID_RANGE: "Дата от - до:",
    VALUE: "Стойност",
    VALUE_NO_VAT: "Стойност без ДДС",
    VALUE_WITH_VAT: "Стойност с ДДС",
    VALUE_VAT: "Стойност  ДДС",
    VALUE_FROM_PROTOCOLS: "Стойност протоколи",
    VAT: "ДДС",
    USERS: "Потребители",
    USER_GROUPS: "Потребителски Групи",
    CUSTOMERS: "Клиенти",
    CUSTOMER_GROUPS: "Клиентски Групи",
    NUMBER_OF_CODES: "Брой кодове:",
    CREATED_AT: "Създаден на",
    UPDATE_AT: "Обновен на",
    IMAGE: "Снимка",
    MACHINE_TYPE: "Тип машина",
    MACHINES_TYPES: "Типове машини",
    MODEL: "Модел",
    REGISTRATION_PLATE: "Рег. номер",
    MACHINE_FUEL_TYPE: "Гориво",
    OWNERSHIP: "Собственост",
    TANK_SIZE: "Обем на резервоара",
    GPS_TRACKER_NUMBER: "GPS номер",
    SUBCONTRACTOR: "Фирма",
    MOTOR_SHIFT_HOURS: "Часовете за една мотосмяна",
    MSM_HOURS: "Часовете за една мотосмяна",
    MSM_PRICE: "Цена на мотосмяна",
    OWNED_MACHINE: "Собствена",
    COMPANY: "Фирма",
    COMPANY_TYPE: "Тип фирма",
    COMPANY_NAME: "Име на фирмата",
    HAS_LOCATION: "Налична локация",
    TANK_NAME: "Име на Бидона",
    TANK_NAME_PLACEHOLDER: "Бидон 1000",
    TANK_LOCATION_PLACEHOLDER: "Расово",
    AVG_PRICE: "Средна цена",
    AVAILABLE_LITERS: "Налични литри",
    CAPACITY: "Вместимост",
    MACHINE: "Машина",
    SERVICE_NAME: "Име на услугата",
    SERVICE_NAME_PLACEHOLDER: "услуга с механизация - водоноска",
    MEASURE_NAME: "Мярка",
    MEASURE_NAME_PLACEHOLDER: "Тон/Курс",
    NOTE: "Забележка",
    QTY: "К-во",
    UNIT_PRICE: "Ед. цена",
    UNIT_TOTAL_PRICE: "Обща сума",
    TOTAL_PRICE: "Сума",
    INVOICE_NUMBER: "Номер на фактура",
    INVOICE_DATE: "Дата на фактура",
    FROM_DATE: "От Дата",
    TO_DATE: "До Дата",
    DETAILS_NAME: "Наименование",
    DATE: "Дата",
    COMPLETED: "Завършен",
    PROTOCOL_NAME: "Номер на протокол",
    PROTOCOL: "Протокол",
    NO_PROTOCOL: "Без протокол",
    NO_ASSIGNOR: "Без възложител",
    ASSIGNOR: "Възложител",
    EXECUTOR_NAME: "Изпълнител",
    EXECUTOR: "Изпълнител",
    LOCATION: "Обект",
    NO_LOCATION: "Без обект",
    DATE_FROM: "Дата от",
    DATE_TO: "Дата до",
    FINISHED_FILTER: "Финализирани",
    INVOICE_FILTER: "Фактурирани",
    SHOW_UNLOADING: "Покажи кариера/разтоварище на справката",
    NOT_FINISHED: "Не е финализиран",
    NO_INVOICE: "Не е фактуриран",
    UNLOADING: "Кариера/разтоварище",
    WORK_DATE: "Дата",
    WORK_QTY: "Брой",
    UNLOADING_TYPE: "Суровина/материал",
    SERVICE: "Услуга",
    TOTAL: "Общо",
    TYPE: "Вид",
    SEARCH_BY_QTY: "Търсене по количество",
    MACHINE_MODEL: "Модел/марка",
    BILL_NUMBER: "Т-ца",
    IS_UNLOADING: "С кариера/разтоварище",
    ADD_NO_INVOICE: "Без фактура",
    QTY: "Количество",
    IS_MILEAGE: "Тип работа",
    HAS_ASSIGNMENTS_FILTER: "С/без ангажименти",
    IS_ASSIGNABLE: "Да се показва в календар",
    PHONE: "Телефонен номер",
    PHONE_SHORT: "Тел.",
    REAL_NAME: "Име на файл",
    FILE_SIZE: "Размер",
    CREATED_AT: "Добавен на",
    FILE: "Файл",
    PERIOD_VALUE: "Километри/моточасове",
    PERIOD_KM: "Километри",
    PERIOD_HOURS: "Моточасове",
    PERIOD_TIME: "Време",
    MONTHS: "Месеци",
    DAYS: "Дни",
    AVAILABLE: "Наличност",
    CAPACITY_QTY: "Капацитет",
    BULSTAT: "Булстат",
    SERVICE_TYPES: "Дейности",
    SERVICE_TYPE: "Дейност/такса",
    VENDOR: "Доставчик",
    WAREHOUSE: "Склад",
    WAREHOUSE_ITEM: "Артикул на склад",
    UPCOMING_SERVICE: "Предстоящо обслужване/задължение",
    EXPENSES: "Разходи",
    CODE: "Код",
    SERVICE_GROUP: "Група",
    MAX_CAPACITY: "Максимален капацитет",
    FIRM_NAME: "Име на фирмата",
    TANK: "Бидон"
  },
  FORM_PLACEHOLDERS: {
    CODE: "Код",
    EMAIL: "Email адрес",
    NAME: "Име",
    FIRST_NAME: "Име",
    LAST_NAME: "Фамилия",
    ACTIVE: "Активен",
    ROLE: "Роля",
    LAT: "Latitude",
    LNG: "Longitude",
    LOCATION: "Местоположение",
    ADDRESS: "Адрес",
    DESCRIPTION: "Описание",
    DESCRIPTION_MAX_140: "Описание (максимум 140 символа)",
    NOTES: "Бележки",
    CITY: "Град",
    SLUG: "Slug",
    CLOCK_CODE: "Clock Code",
    PASS_CODE: "Pass Code",
    HOURLY_RATE: "Hourly Rate",
    LANG: "Език",
    PASSWORD: "Парола",
    FOR_BRAND: "За Бранд",
    ITEM_CATEGORY_TYPE: "Тип категория",
    ITEM_RECIPE_ADDON: "Добавка към рецепта",
    SORT: "Подредба",
    TITLE: "Заглавие",
    ICON: "Иконка",
    IMG: "Снимка",
    MACHINE_TYPE: "4 оси, 30 тона, и т.н.",
    MACHINE_MODEL: "Модел/марка",
    MACHINE_REGISTRATION_PLATE: "Регистрационнен номер",
    MACHINE_REGISTRATION_PLATE_SHORT: "CA7878CB",
    TANK_SIZE: "в литри",
    GPS_TRACKER_NUMBER: "ID от системата",
    PROTOCOL_NAME: "17",
    STAFF_NAME: "Служител",
    TYPE: "Вид",
    MACHINE: "Машина",
    MACHINES: "Машина/и",
    IS_UNLOADING: "С кариера/разтоварище",
    NO_MILEAGE: "Без километраж/моточасове",
    IS_ASSIGNABLE: "Да се показва в календар",
    DATES: "Дати",
    PHONE: "Пример: 0881234567",
    PERIOD_TYPE: "Тип на периодичност"
  },

  LABELS: {
    FILTERS: "Филтри",
    DETAILS: "Детайли",
    SENT: "Изпратено",
    SENT_SUCCESS_TO_LYUNIK_STROI: "Успешно изпращане в Люник Строй",
    DUPLICATE_INVOICE: "Вече съществува фактура с този номер и еик!",
    ERROR_LOADING_ACCOUNTING_VALUES:
      "Грешка при зареждане на счетоводните сметки",
    TO_ACCOUNTING: "За счетоводство",
    YES: "Да",
    NO: "Не",
    SAVE: "Запази",
    SERVICE_VENDOR_AUTO_MATCHED_BY_VAT:
      "Доставчик - Автоматично съпоставен по ДДС/Булстат номер",
    DEFAULT_WAREHOUSE_ITEM: "Основен складов артикул (филтър в зареждания)",
    DEFAULT_WAREHOUSE_TOOLTIP: "Ще се попълва по подразбиране в разходи.",
    DEFAULT_MACHINE_FUEL_TOOLTIP:
      "Ще се попълва по подразбиране в нови зареждания.",
    DEFAULT_MACHINE_SERVICE_TOOLTIP:
      "Ще се попълва по подразбиране в нови разходи.",
    DEFAULTS_ACTIVE: "Тази машина/склад ще се попълва по подразбиране.",
    DEFAULT_MACHINE_ACTIVE:
      "Тази машина ще се попълва по подразбиране в нови зареждания.",
    DEFAULT_MACHINE: "Основна машина (филтър в зареждания)",
    PROCEED_ANYWAY: "Продължи все пак",
    DELETE_INVOICE: "Сигурни ли сте, че искате да изтриете фактурата?",
    EXPENSES: "Разходи",
    PRICE_MISMATCH_WARNING:
      "Цената на фактурата не съвпада с изчислената от редовете",
    PRICE_MISMATCH_WARNING: "Предупреждение за несъответствие на цената",
    AI_INVOICE_TOTAL: "Обща сума на AI фактурата",
    CALCULATED_TOTAL: "Изчислена обща сума от редовете",
    DIFFERENCE: "Разлика",
    ADD_ROW: "Добави ред",
    MACHINE_OR_WAREHOUSE_REQUIRED: "Машина или складов артикул е задължителен",
    ADD_EXPENSE: "Добави разход",
    REQUIRED: "Задължително поле",
    NO_ADDED_ROWS:
      "Няма добавени редове. Натиснете Добави ред за да започнете.",
    NO_TANK_CHARGES: "Няма зареждания за показания период",
    KM: "км",
    LITERS: "л.",
    NA: "N/A",
    GAS_STATION_AUTO_MATCHED_BY_VAT:
      "Бензиностанция - Автоматично съпоставена по ДДС номер",
    INFO: "Инфо",
    FORM_PREFILLED_FROM_AI_INVOICE:
      "Формата е предварително попълнена от AI фактура",
    TOTAL: "Общо",
    AI_INVOICE_ITEMS: "Артикули от AI фактура",
    CREATE_FUEL_EXPENSE: "Създаване на разход за гориво",
    CREATE_MATERIAL_EXPENSE: "Създаване на разход за материали",
    CREATE_SUBCONTRACTOR_EXPENSE: "Създаване на разход за подизпълнител",
    CREATE_SERVICE_INVOICE: "Създаване на фактура за сервиз",
    FROM_AI_INVOICE: "От AI фактура",
    AI_INVOICE_REFERENCE: "Референция към AI фактура",
    INVOICE_ITEMS: "Артикули на фактурата",
    FUEL_EXPENSE_PREFILLED_FROM_AI_INVOICE:
      "Разходът за гориво е предварително попълнен от AI фактура",
    ERROR_LOADING_AI_INVOICE: "Грешка при зареждане на AI фактурата",
    TOTALS: "Общо",
    ADD_MANUAL: "Добави ръчно",
    ALL: "Всички",
    NOT_PROCESSED: "Необработени",
    PROCESSED: "Обработени",
    INVOICE_UPDATED_SUCCESS: "Фактурата е успешно обновена",
    INVOICE_UPDATE_ERROR: "Грешка при обновяване на фактурата",
    ALL_CHANGES_SAVED_SUCCESS: "Всички промени са успешно записани",
    ALL_CHANGES_SAVE_ERROR: "Грешка при запис на промените",
    ROWS_UPDATED_SUCCESS: "Редовете са успешно обновени",
    ROWS_UPDATE_ERROR: "Грешка при обновяване на редовете",
    COMPANY_CONFIRM_ERROR: "Грешка при потвърждаване на фирмата",
    COMPANY_CONFIRMED_SUCCESS: "Фирмата е успешно потвърдена",
    NOT_FOUND: "Не е намерено",
    INVOICE_TYPE_NOT_FOUND: "Типът фактура не е намерен",
    ADD_NEW_COMPANY: "Добавяне на нова фирма",
    EDIT_COMPANY: "Редактиране на фирма",
    ERROR_SAVING_COMPANY: "Грешка при запис на фирмата",
    ERROR_LOADING_COMPANYS: "Грешка при зареждане на фирмите",
    ADD_NEW_COMPANY: "Добавяне на нова фирма",
    TOTAL_SUM: "Обща сума",
    COMPANY_NOT_CONFIRMED: "Компанията не е потвърдена",
    CLICK_TO_CONFIRM: "Натиснете за да потвърдите",
    CONFIRM_COMPANY: "Потвърди компания",
    CONFIRM: "Потвърди",
    CANCEL: "Отказ",
    CONFIRM_COMPANY_MESSAGE:
      "Сигурни ли сте, че искате да потвърдите {type}: {name}?",
    SUPPLIER: "доставчик",
    BUYER: "купувач",
    COMPANY_CONFIRMED_SUCCESS: "Компанията е потвърдена успешно",
    COMPANY_CONFIRM_ERROR: "Грешка при потвърждаване на компанията",
    COMPANY_NOT_CONFIRMED: "Компанията не е потвърдена",
    UPLOAD_INVOICES: "Качване на фактури",
    UPLOAD_FILES: "Качи файлове",
    FILES_SELECTED: "файла избрани",
    UPLOADING: "Качване...",
    UPLOAD: "Качи",
    UPLOAD_SUCCESS_MULTIPLE: "{count} файла качени успешно",
    UPLOAD_FAILED: "Качването не успя",
    INVOICES_PROCESSING:
      "Качените фактури се обработват. Това може да отнеме няколко минути.",
    INVOICES_PROCESSING_INFO:
      "Качените фактури се обработват. Това може да отнеме няколко минути. Когато има обработени фактури ще видите бутон 'Обнови'.",
    NEW_INVOICES_ADDED:
      "Има добавена нова фактура. Натиснете 'Обнови' за да обновите таблицата.",
    REFRESH: "Обнови",
    UPLOAD_FILES: "Качване на файлове",
    FILES_SELECTED: "избран(и) файл(ове)",
    UPLOAD_SUCCESS_MULTIPLE: "{count} файла(ове) качени успешно",
    UPLOAD_PROGRESS: "Напредък на качването",
    PROCESSING: "Обработка...",
    COMPLETED: "Завършено",
    TIMEOUT: "Изтекло време",
    ALL_INVOICES_PROCESSED: "Всички фактури обработени успешно",
    POLLING_TIMEOUT_FOR_FILE: "Изтекло време при обработката на {fileName}",
    SAVE_CHANGES: "Запази промените",
    DATA_NOT_CORRECT: "Данни не са коректни",
    NO_RESULTS: "Няма намерени резултати.",
    POLLING_FOR_INVOICE: "Изчакване на обработка на фактурата...",
    POLLING_ATTEMPT: "Опит {n} за намиране на новата фактура...",
    INVOICE_FOUND: "Фактурата е намерена! Пренасочване...",
    POLLING_TIMEOUT: "Фактурата не беше намерена в рамките на 1 минута.",
    UPLOAD: "Качи",
    UPLOADING: "Качване...",
    UPLOAD_FILE: "Качи файл",
    UPLOAD_SUCCESS: "Файлът е качен успешно!",
    LOCATION: "Локация",
    BILL_NUMBER: "Т-ца №",
    MACHINE: "Машина",
    SERVICE_NAME: "Име на услугата",
    WORK_DONE: "Извършена работа",
    LOCATION_NAME: "Име на локацията",
    CONFIRM_DELETE: "Потвърди изтриване",
    DELETE_CONFIRMATION_MESSAGE:
      "Сигурни ли сте, че искате да изтриете този запис?",
    ITEM_DELETED_SUCCESSFULLY: "Изтрито успешно",
    DELETE_ERROR: "Грешка при изтриване",
    NO_DATA: "Няма данни",
    NO_PERMISSIONS: "Няма права",
    LIST: "Списък",
    ADDRESS: "Адрес",
    ADD_NEW: "Добавяне",
    EXPORT: "PDF",
    EDIT: "Редактиране",
    CLEAR: "Изчистване",
    SEARCH: "Търсене",
    ADD_POLYGON: "Добави полигон",
    RESET_POLYGON: "Изчисти полигон",
    RECENTER_MAP: "Центрирай картата",
    STEP: "Стъпка",
    VIEW: "Преглед",
    SHOW_BILLS_OF_LADING: "Покажи товарителници",
    PRINT: "Разпечатай",
    SEARCH_BOL:
      "Търсене по номер, услуга, регистрационен номер, протокол, машина",
    SHOW_BILLS_OF_LADING_WORK: "Покажи дейности към товарителници",
    FILES: "Файлове",
    DOWNLOAD: "Изтегляне",
    PERIOD_TYPE_HOURS: "Километри",
    PERIOD_TYPE_KM: "Километри",
    PERIOD_TYPE_HOURS: "Моточасове",
    PERIOD_TYPE_KMORTIME: "Километри или време",
    PERIOD_TYPE_HOURSORTIME: "Моточасове или време",
    PERIOD_TYPE_TIME: "Време",
    PERIOD_TYPE_NONE: "Без периодичност",
    YEAR: "Година",
    WEEK: "Седмица",
    DAY: "Ден",
    DELETE: "Изтриване"
  },
  WEEK_DAYS: {
    MONDAY: "ПОНЕДЕЛНИК",
    TUESDAY: "ВТОРНИК",
    WEDNESDAY: "СРЯДА",
    THURSDAY: "ЧЕТВЪРТЪК",
    FRIDAY: "ПЕТЪК",
    SATURDAY: "СЪБОТА",
    SUNDAY: "НЕДЕЛЯ",
    DAYS: "ДНИ"
  },
  ALERTS: {
    SUCCESS: "Успех",
    ERROR: "Грешка",
    NO_DATA: "Няма данни",
    WARNING: "Вниемание",
    BILL_NUMBER_EXIST: "Вече съществува товарителница с този номер!",
    SUCCESSFUL_DELETE: "Успешно изтриване",
    TANK_CHARGE_REQUIRED_SHORT: "Зареждането е задължително",
    MISSING_REQUIRED_FIELDS: "Липсват задължителни полета",
    FILL_FIELDS: "Моля попълнете всички задължителни полета"
  },
  ASSIGNMENTS: {
    MACHINE: "Машина",
    DAYS: {
      mon: "Пон",
      tue: "Вто",
      wed: "Сря",
      thu: "Чет",
      fri: "Пет",
      sat: "Съб",
      sun: "Нед"
    },
    TYPE: "Тип",
    DATE: "Дата",
    START_TIME: "Начален час",
    END_TIME: "Краен час",
    IS_FULL_DAY: "Целодневен ангажимент",
    DESCRIPTION: "Описание",
    CONFIRM_RESEND_NOTIFICATIONS:
      "Желаете ли да изпратите отново седмичния график на служителя по Viber?"
  },
  ACTION_STATUS: {
    IS_SET: "Действието предстои да започне.",
    IS_RUNNING: "Действието все още е в процес на извършване.",
    IS_FINISHED: "Действието е извършено успешно.",
    IS_FAILED: "Действието е извършено неуспешно.",
    IS_CANCELLED: "Действието е прекратено.",
    REFRESH_STATUS:
      "За да проследите дали статуса се е сменил, моля презаредете."
  },
  PERMISSIONS: {
    "assignors-groups-show": "Групи възложители - списък",
    "assignors-groups-create": "Групи възложители - добавяне",
    "assignors-groups-update": "Групи възложители - обновяване",
    "assignors-groups-delete": "Групи възложители - изтриване",
    "assignors-show": "Възложители - списък",
    "assignors-create": "Възложители - добавяне",
    "assignors-update": "Възложители - обновяване",
    "assignors-delete": "Възложители - изтриване",
    "executors-show": "Изпълнители - списък",
    "executors-create": "Изпълнители - добавяне",
    "executors-update": "Изпълнители - обновяване",
    "executors-delete": "Изпълнители - изтриване",
    "assignor-locations-show": "Обекти възложители - списък",
    "assignor-locations-create": "Обекти възложители - добавяне",
    "assignor-locations-update": "Обекти възложители - обновяване",
    "assignor-locations-delete": "Обекти възложители - изтриване",
    "subcontractors-show": "Подизпълнители - списък",
    "subcontractors-create": "Подизпълнители - добавяне",
    "subcontractors-update": "Подизпълнители - обновяване",
    "subcontractors-delete": "Подизпълнители - изтриване",
    "subcontractor-locations-show": "Обекти подизпълнители - списък",
    "subcontractor-locations-create": "Обекти подизпълнители - добавяне",
    "subcontractor-locations-update": "Обекти подизпълнители - обновяване",
    "subcontractor-locations-delete": "Обекти подизпълнители - изтриване",
    "gas-stations-show": "Бензиностанции - списък",
    "gas-stations-create": "Бензиностанции - добавяне",
    "gas-stations-update": "Бензиностанции - обновяване",
    "gas-stations-delete": "Бензиностанции - изтриване",
    "staff-show": "Служители - списък",
    "staff-create": "Служители - добавяне",
    "staff-update": "Служители - обновяване",
    "staff-delete": "Служители - изтриване",
    "staff-vehicle-show": "Лични автомобили - списък",
    "staff-vehicle-create": "Лични автомобили - добавяне",
    "staff-vehicle-update": "Лични автомобили - обновяване",
    "staff-vehicle-delete": "Лични автомобили - изтриване",
    "machines-types-show": "Типове машини - списък",
    "machines-types-create": "Типове машини - добавяне",
    "machines-types-update": "Типове машини - обновяване",
    "machines-types-delete": "Типове машини - изтриване",
    "machines-show": "Собствени машини - списък",
    "machines-create": "Собствени машини - добавяне",
    "machines-update": "Собствени машини - обновяване",
    "machines-delete": "Собствени машини - изтриване",
    "rented-machines-show": "Наети машини - списък",
    "rented-machines-create": "Наети машини - добавяне",
    "rented-machines-update": "Наети машини - обновяване",
    "rented-machines-delete": "Наети машини - изтриване",
    "tank-charges-show": "Зареждане от бидони - списък",
    "tank-charges-create": "Зареждане от бидони - добавяне",
    "tank-charges-update": "Зареждане от бидони - обновяване",
    "tank-charges-delete": "Зареждане от бидони - изтриване",
    "bill-of-lading-show": "Товарителници - списък",
    "bill-of-lading-create": "Товарителници - добавяне",
    "bill-of-lading-update": "Товарителници - обновяване",
    "bill-of-lading-delete": "Товарителници - изтриване",
    "protocols-show": "Протоколи - списък",
    "protocols-create": "Протоколи - добавяне",
    "protocols-update": "Протоколи - обновяване",
    "protocols-delete": "Протоколи - изтриване",
    "protocols-finalize": "Протоколи - финализиране",
    "fuel-expenses-show": "Разходи горива - списък",
    "fuel-expenses-create": "Разходи горива - добавяне",
    "fuel-expenses-update": "Разходи горива - обновяване",
    "fuel-expenses-delete": "Разходи горива - изтриване",
    "subcontractors-invoices-show": "Разходи подизпълнители - списък",
    "subcontractors-invoices-create": "Разходи подизпълнители - добавяне",
    "subcontractors-invoices-update": "Разходи подизпълнители - обновяване",
    "subcontractors-invoices-delete": "Разходи подизпълнители - изтриване",
    "subcontractors-invoices-materials-show": "Разходи материали - списък",
    "subcontractors-invoices-materials-create": "Разходи материали - добавяне",
    "subcontractors-invoices-materials-update":
      "Разходи материали - обновяване",
    "subcontractors-invoices-materials-delete": "Разходи материали - изтриване",
    "services-show": "Услуги - списък",
    "services-create": "Услуги - добавяне",
    "services-update": "Услуги - обновяване",
    "services-delete": "Услуги - изтриване",
    "measures-show": "Мерки - списък",
    "measures-create": "Мерки - добавяне",
    "measures-update": "Мерки - обновяване",
    "measures-delete": "Мерки - изтриване",
    "fuels-types-show": "Видове горива - списък",
    "fuels-types-create": "Видове горива - добавяне",
    "fuels-types-update": "Видове горива - обновяване",
    "fuels-types-delete": "Видове горива - изтриване",
    "subcontractors-types-show": "Типове подизпълнители - списък",
    "subcontractors-types-create": "Типове подизпълнители - добавяне",
    "subcontractors-types-update": "Типове подизпълнители - обновяване",
    "subcontractors-types-delete": "Типове подизпълнители - изтриване",
    "tanks-show": "Бидони - списък",
    "tanks-create": "Бидони - добавяне",
    "tanks-update": "Бидони - обновяване",
    "tanks-delete": "Бидони - изтриване",
    "users-show": "Потребители - списък",
    "users-create": "Потребители - добавяне",
    "users-update": "Потребители - обновяване",
    "users-delete": "Потребители - изтриване",
    "roles-show": "Роли - списък",
    "roles-create": "Роли - добавяне",
    "roles-update": "Роли - обновяване",
    "roles-delete": "Роли - изтриване",
    "statistics-show": "Статистики",
    "assignments-show": "Ангажименти - списък",
    "assignments-create": "Ангажименти - добавяне",
    "assignments-update": "Ангажименти - обновяване",
    "assignments-delete": "Ангажименти - изтриване",
    "service-show": "Сервиз - списък",
    "service-create": "Сервиз - добавяне",
    "service-update": "Сервиз - обновяване",
    "service-delete": "Сервиз - изтриване",
    "service-locations-show": "Сервизни локации - списък",
    "service-locations-create": "Сервизни локации - добавяне",
    "service-locations-update": "Сервизни локации - обновяване",
    "service-locations-delete": "Сервизни локации - изтриване",
    "service-visits-show": "Сервизни посещения - списък",
    "service-visits-create": "Сервизни посещения - добавяне",
    "service-visits-update": "Сервизни посещения - обновяване",
    "service-visits-delete": "Сервизни посещения - изтриване",
    "mechanic": "Механик",
    "transport-manager": "Началник на транспорт",
    "mechanics-show": "Механици - списък",
    "mechanic-hours-show": "Часове механици - списък",
    "mechanic-hours-create": "Часове механици - добавяне",
    "mechanic-hours-update": "Часове механици - обновяване",
    "mechanic-hours-delete": "Часове механици - изтриване",
    "ai-invoices-show": "AI Фактури - списък",
    "ai-invoices-create": "AI Фактури - добавяне",
    "ai-invoices-update": "AI Фактури - обновяване",
    "ai-invoices-delete": "AI Фактури - изтриване",
    "ai-invoice-rows-show": "AI Фактури редове - списък",
    "ai-invoice-rows-create": "AI Фактури редове - добавяне",
    "ai-invoice-rows-update": "AI Фактури редове - обновяване",
    "ai-invoice-rows-delete": "AI Фактури редове - изтриване",
    "machine-service-signals-show": "Сигнали за сервиз на машини - списък",
    "machine-service-signals-delete": "Сигнали за сервиз на машини - изтриване",
    "ai-companies-show": "AI Фирми - списък",
    "ai-companies-create": "AI Фирми - добавяне",
    "ai-companies-update": "AI Фирми - обновяване",
    "ai-invoice-accounting-value-types-show": "Счетоводни сметки - списък",
    "ai-invoice-accounting-value-types-create":
      "Счетоводни сметки - добавяне",
    "ai-invoice-accounting-value-types-update":
      "Счетоводни сметки - обновяване",
    "ai-invoice-accounting-value-types-delete":
      "Счетоводни сметки - изтриване",
    "ai-invoice-accounting-values-show": "Счетоводни стойности - списък",
    "ai-invoice-accounting-values-create":
      "Счетоводни стойности - добавяне",
    "ai-invoice-accounting-values-update":
      "Счетоводни стойности - обновяване",
    "ai-invoice-accounting-values-delete":
      "Счетоводни стойности - изтриване",
    "gps-tank-charges-show": "GPS - зареждане от бидони - списък",
    "gps-tank-charges-transfer": "GPS - зареждане от бидони - потвърждение",
    "gps-tank-charges-delete": "GPS - зареждане от бидони - изтриване",
    "gps-tanks-show": "GPS - бидони - списък"
  }
};
